module.exports = __webpack_public_path__ + "static/img/exam-10-3-bg.292286a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-10-3-bg.png
// module id = 6w2z
// module chunks = 1